import { useQuery } from '@tanstack/react-query';
import { marketsApi } from '../services/api/markets';

export const useMarketSearch = (query: string) => {
  return useQuery({
    queryKey: ['marketSearch', query],
    queryFn: () => marketsApi.searchMarkets(query),
    enabled: query.length >= 4,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};